
import { Context, notify } from './context'
import { fetchEventSource } from '@microsoft/fetch-event-source'

export { ApiClient, User, ChatSession, UserOrder, ChatBot, ChatMessage, DataSet }



class ApiClient {
  static baseUrl = '/api'

  static async request(method, path, data=null, headers=null, needExtra=false) {
    path = path[0] != '/' ? '/' + path : path
    let url = this.baseUrl + path

    /* use POST for GET
    if (data && method == 'GET') {
      let params = []
      for (let k in data) {
        let v = data[k]
        if (v === null || v === undefined || v === '')
          continue
        params.push(`${k}=${v}`)
      }
        
      url += `?` + params.join('&')
      data = null
    }*/
    
    let defaultHeaders = {
      'X-Token': Context.getToken() || '',
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
    }

    // fuck ISP HTTP-GET hijack
    if (method == 'GET') {
      defaultHeaders['X-Method'] = 'GET'
      method = 'POST'
    }

    let reqArgs = {
      method: method,
      headers: Object.assign(headers || {}, defaultHeaders),
    }

    //if (data) reqArgs.body = JSON.stringify(data)
    reqArgs.body = JSON.stringify(data || {})

    /*console.time('fetch')
    return fetch(url, reqArgs).then(
      resp => resp.json()
    ).then(obj => {
      console.timeEnd('fetch')
      if (!obj.success) {
        console.log(`API ERROR: ${method} ${url}:${JSON.stringify(data)} -> ${JSON.stringify(obj.error)}`)
        return null
      }
      return obj.result
    }).catch(err => {
      throw new Error(`REQUEST ERROR: ${err} ${method} ${url}:${JSON.stringify(data)}`)
    })*/

    let ok = false
    let retries = 0
    let resp = null
    while (!ok && retries < 3) {
      retries += 1
      try {
        resp = await fetch(url, reqArgs)
        ok = true
      } catch (err) {
        notify(`请求失败:${err}`, 'error')
        console.log(`REQUEST ERROR: ${method} ${url}:${JSON.stringify(data)} -> ${err}`)
      }
    }
    if (!ok) return null;

    if (!resp.ok) {
      notify(`响应失败${resp.status}`, 'error')
      console.log(`RESPONSE ERROR: ${method} ${url}:${JSON.stringify(data)} -> ${resp.status}`)
      return null
    }

    let obj = await resp.json()
    if (!obj || !obj.success) {
      notify(obj.error.detail || obj.error.message, 'error')
      console.log(`API ERROR: ${method} ${url}:${JSON.stringify(data)} -> ${JSON.stringify(obj.error)}`)
      return null
    }

    // missing extra_result
    if (needExtra) {
      return [obj.result, obj.extra_result]
    } else {
      return obj.result
    }
  }

  static async GET(path, data=null, needExtra=false) {
    return await this.request('GET', path, data, null, needExtra)
  }

  static async POST(path, data) {
    return await this.request('POST', path, data)
  }

  static async PATCH(path, data) {
    return await this.request('PATCH', path, data)
  }

  static async DELETE(path) {
    return await this.request('DELETE', path)
  }

  static async STREAMING(path, messageFunc) {
    path = path[0] != '/' ? '/' + path : path
    let url = this.baseUrl + path

    try{
      await fetchEventSource(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Token': Context.getToken(),
        },
        body: '{}',
        openWhenHidden: true, // Fuck ms
        onmessage: (msg) => {
          if (msg.event == 'end') {
            throw new Error('END')
          } else if (msg.event == 'error') {
            let err = JSON.parse(msg.data)
            notify(err.detail || err.message, 'error')
            console.log(`STREAM ERROR: ${url}: ${JSON.stringify(err)}`)
            throw new Error('ERROR')
          }
          messageFunc(msg)
        },
        onerror: (err) => {
          throw err // abort connection, dont retry
        }
      })
    } catch (e) {}
    //return new EventSource(url) // Fuck native EventSource API
  }

  static async sendCode(mobile) {
    return await this.GET(`/application/_send_code?mobile=${mobile}`)
  }

  static async getUploadToken() {
    let res = await this.GET('/application/_upload_token')
    return res && res.token
  }
}

class BaseModel { 
  // property without _xxx is data field
  static _endpoint = 'UNDEFINED_ENDPOINT'
  constructor(data) {
    this._fields = []
    this.loadData(data)
    this._endpoint = this.constructor._endpoint // holy shit
  }

  loadData(data) {
    this._data = data
    this._updateData = {}

    Object.keys(data).forEach(key => {
      if (this._fields.includes(key))
        return

      this._fields.push(key)
      Object.defineProperty(this, key, {
        get: function () {
          return this._data[key]
        },
        set: function (newValue) {
          this._data[key] = newValue
          this._updateData[key] = newValue
        }
      })
    })
  }

  static make(data) { return new this(data) }
  static makeList(dataList) { return dataList.map((d) => new this(d)) }
  static async getOne(id) {
    let res = await ApiClient.GET(`/${this._endpoint}/${id}`)
    return this.make(res)
  }

  setValue(key, value) {
    if (!this._fields.includes(key)) this._fields.push(key)
    this._data[key] = value
    this._updateData[key] = value
  }

  async create(data) {
    data = data || {}
    this._fields.forEach(f => data[f] = this[f])
    let res = await ApiClient.POST(`/${this._endpoint}`, data)
    if (!res) return false
    this.loadData(res)
    return true
  }

  async update() {
    let res = await ApiClient.PATCH(`/${this._endpoint}/${this.id}`, this._updateData)
    if (!res) return false
    this.loadData(res)
    return true
  }

  async delete() {
    let res = await ApiClient.DELETE(`/${this._endpoint}/${this.id}`)
    return res ? true : false
  }
}

class User extends BaseModel {
  static _endpoint = 'user'
  constructor(data) { super(data) }

  static async get() {
    let res = await ApiClient.GET(`/${this._endpoint}?me=1`)
    return res && this.make(res)
  }

  static async auth(token) {
    let res = await ApiClient.POST(`/${this._endpoint}/_auth`, {token: token})
    return res && this.make(res)
  }

  static async register(mobile, code, password, inviteCode='') {
    let res = await ApiClient.POST(
      `/${this._endpoint}`,
      {mobile: mobile, code: code, password: password, invite_code: inviteCode}
    )
    return res && this.make(res)
  }

  static async login(mobile, code, password) {
    let res = await ApiClient.POST(`/${this._endpoint}/_login`, {mobile: mobile, code: code, password: password})
    return res && this.make(res)
  }

  static async get_wx_qrcode() {
    let res = await ApiClient.POST(`/${this._endpoint}/_wx_qrcode`)
    return res
  }
}

class ChatSession extends BaseModel {
  static _endpoint = 'session'
  constructor(data) { super(data) }

  static async getList(botId) {
    let res = await ApiClient.GET(`/${this._endpoint}`, {mine: 1, start_bot_id: botId})
    return res ? this.makeList(res) : [];
  }

  async clear() {
    let res = await ApiClient.POST(`/${this._endpoint}/${this.id}/_clear`,)
    return res ? true : false
  }
}

class UserOrder extends BaseModel {
  static _endpoint = 'order'
  constructor(data) { super(data) }
}

class ChatBot extends BaseModel {
  static _endpoint = 'chatbot'
  constructor(data) { super(data) }

  static async getMine() {
    let res = await ApiClient.GET('/chatbot?mine=1')
    return res ? this.makeList(res) : [];
  }

  static async getHot(count=50) {
    let res = await ApiClient.GET(`/chatbot?hot=1&count=${count}`)
    return res ? this.makeList(res) : [];
  }

  static async getByCategory(category) {
    let res = await ApiClient.GET('/chatbot', {category: category})
    return res ? this.makeList(res) : [];
  }

  async follow() {
    let res = await ApiClient.GET(`/chatbot/${this.id}/_follow`)
    if (!res) return false
    this.following = true
    return true
  }

  async unfollow() {
    let res = await ApiClient.GET(`/chatbot/${this.id}/_unfollow`)
    if (!res) return false
    this.following = false
    return true
  }
}

class ChatMessage extends BaseModel {
  static _endpoint = 'message'
  constructor(data) { super(data) }

  static async getList(sessionId) {
    let res = await ApiClient.GET(`/session/${sessionId}/${this._endpoint}`)
    return res ? this.makeList(res) : [];
  }

  static async getStarList(last_id=null, count=20) {
    let res = await ApiClient.GET(`/${this._endpoint}`, {star:1,last_id:last_id,count:count})
    return res ? this.makeList(res) : [];
  }

  async stream(onmessage) {
    if (!this.id) return
    await ApiClient.STREAMING(`/${this._endpoint}/${this.id}/_streaming`, onmessage)
  }

  async star() {
    if (!this.id) return
    let res = await ApiClient.GET(`/message/${this.id}/_star`)
    return res ? true : false
  }

  async unstar() {
    if (!this.id) return
    let res = await ApiClient.GET(`/message/${this.id}/_unstar`)
    return res ? true : false
  }
}

class DataSet extends BaseModel {
  static _endpoint = 'dataset'
  constructor(data) { super(data) }

  static async getList(botId, lastId=null) {
    let res = await ApiClient.GET(`/bot/${botId}/dataset`, {last_id:lastId})
    return res ? this.makeList(res) : []
  }
  
  static async search(botId, text) {
    let res = await ApiClient.GET(`/bot/${botId}/dataset/_search`, {text:text})
    return res ? this.makeList(res) : []
  }

  static async enable(botId) {
    let res = await ApiClient.POST(`/bot/${botId}/dataset/_enable`)
    return res ? res.ok : false
  }

  static async addFile(botId, fileName, fileUrl) {
    let res = await ApiClient.POST(
      `/bot/${botId}/dataset/_addfile`, 
      {file_name: fileName, file_url: fileUrl}
    )
    return res ? res.ok : false
  }

  static async bulk(botId, data) {
    let res = await ApiClient.POST(`/bot/${botId}/dataset/_bulk`, {data:data})
    return res ? true : false
  }

  static async empty(botId) {
    let res = await ApiClient.POST(`/bot/${botId}/dataset/_empty`)
    return res ? res.ok : false
  }

  async update() {
    let res = await ApiClient.PATCH(
      `/bot/${this.bot_id}/${this._endpoint}`, 
      {id: this.id, content: this.content}
    )
    if (!res) return false
    this.loadData(res)
    return true
  }

  async delete() {
    let res = await ApiClient.DELETE(`/bot/${this.bot_id}/${this._endpoint}?id=${this.id}`)
    return res ? true : false
  }

}